import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  selectedToggle: PropTypes.string,
};

const defaultProps = {
  className: '',
  onClick: () => {},
  selectedToggle: '',
};

const ButtonToggle = ({ children, className, onClick, selectedToggle }) => (
  <div className={`row toggle-button-group ${className}`}>
    {Children.map(children, child => cloneElement(child, { onClick, selectedToggle }))}
  </div>
);

ButtonToggle.propTypes = propTypes;
ButtonToggle.defaultProps = defaultProps;

export default ButtonToggle;
